// Screens/PasswordScreen.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PasswordScreen = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Change this to your desired password
  const correctPassword = process.env.REACT_APP_SITE_PASSWORD;

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (password === correctPassword) {
      localStorage.setItem("isAuthenticated", "true");
      navigate("/");
    } else {
      setError("Incorrect password. Please try again.");
      setPassword("");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
      className="bg-gradient-to-br from-gray-900 to-gray-800"
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "white",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          textAlign: "center",
          minWidth: "300px",
        }}
      >
        <h2 style={{ marginBottom: "1rem", color: "#333" }}>
          🔒 Protected Access
        </h2>
        <p style={{ marginBottom: "1.5rem", color: "#666" }}>
          Please enter the password to continue
        </p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          style={{
            width: "100%",
            padding: "0.75rem",
            margin: "1rem 0",
            border: `2px solid ${error ? "#ff4757" : "#ddd"}`,
            borderRadius: "6px",
            fontSize: "1rem",
            outline: "none",
            transition: "border-color 0.3s",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#667eea")}
        />
        {error && (
          <p
            style={{
              color: "#ff4757",
              margin: "0.5rem 0",
              fontSize: "0.9rem",
            }}
          >
            {error}
          </p>
        )}
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "0.75rem",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "1rem",
            cursor: "pointer",
            transition: "transform 0.2s",
          }}
          onMouseOver={(e) =>
            ((e.target as HTMLButtonElement).style.transform =
              "translateY(-2px)")
          }
          onMouseOut={(e) =>
            ((e.target as HTMLButtonElement).style.transform = "translateY(0)")
          }
        >
          Unlock Site
        </button>
      </form>
    </div>
  );
};

export default PasswordScreen;
